import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { IdeaDto } from './idea-dto';
import { IdeaserviceService } from '../_services/ideaservice.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-idea',
  templateUrl: './idea.component.html',
  styleUrls: ['./idea.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatIconModule],
})
export class IdeaComponent implements OnInit {
  ideas: IdeaDto[] = [];
  form: UntypedFormGroup;

  constructor(private ideaserviceService: IdeaserviceService, private fb: UntypedFormBuilder, private cdr: ChangeDetectorRef) {
    this.form = this.fb.group({
      ideaname: new UntypedFormControl(''),
    });
  }

  ngOnInit(): void {
    this.loadIdeas();
  }

  private loadIdeas(): void {
    this.ideaserviceService.getIdeas().subscribe({
      next: (data) => {
        const result = JSON.parse(data);
        if (Array.isArray(result)) {
          this.ideas = result;
          this.cdr.detectChanges();
        }
      },
      error: () => {},
    });
  }

  removeItem(id: number): void {
    this.ideaserviceService.removeIdea(id).subscribe({
      next: (data) => {
        const result = JSON.parse(data);
        if (Array.isArray(result)) {
          this.ideas = result;
          this.cdr.detectChanges();
        }
      },
      error: () => {},
    });
  }

  submit(): void {
    const postData = this.form.value;
    this.ideaserviceService.newIdea(postData).subscribe({
      next: (data) => {
        const result = JSON.parse(data);
        if (Array.isArray(result)) {
          this.ideas = result;
          this.cdr.detectChanges();
        }
        this.form.reset({ ideaname: '' });
      },
      error: () => {},
    });
  }
}
